// extracted by mini-css-extract-plugin
module.exports = {"base":"BackArrow_base__1bvMK","arrow":"BackArrow_arrow__1e7aO","upper":"BackArrow_upper__246dH","lower":"BackArrow_lower__2xnqG","slimStile":"BackArrow_slimStile__jbFzg"};